// web/src/components/common/SiteFooter.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const mail = "contact.etatdulieu@gmail.com";
  const linkedinUrl = "https://www.linkedin.com/company/etat-du-lieu/";

  return (
    <footer className="site-footer" role="contentinfo" aria-label="Pied de page">
      <style>{`
        .site-footer{
          margin-top:72px;
          background: rgba(255,255,255,0.12);
          border-top: 1px solid rgba(255,255,255,0.35);
          backdrop-filter: blur(18px);
          border-radius:16px;
          color:#fff;
        }
        .site-footer .inner{
          max-width:1200px; margin:0 auto; padding:32px 20px;
        }
        .site-footer .cols{
          display:grid; gap:20px;
          grid-template-columns: minmax(0,1fr) auto;
        }
        .site-footer h4{
          margin:0 0 10px; font-size:1rem; font-weight:800; color:#fff;
        }
        .site-footer ul{ list-style:none; padding:0; margin:0; }
        .site-footer li{ margin:8px 0; font-size:.98rem; }
        .site-footer a{ color:#fff; text-decoration:none; }
        .site-footer a:hover{ text-decoration:underline; }
        .site-footer .contact-line{
          margin-top:12px; padding:12px 14px; text-align:center;
        }
        .site-footer .bottom{
          display:flex; flex-wrap:wrap; gap:10px;
          margin-top:16px; padding-top:16px;
          border-top:1px dashed rgba(255,255,255,0.35);
          font-size:.92rem; color:rgba(255,255,255,0.9);
          justify-content:space-between; align-items:center;
        }
        .site-footer .socials{
          display:flex; align-items:center; gap:10px;
        }
        .site-footer .social-link{
          display:inline-flex; align-items:center; gap:8px;
          padding:6px 10px; border-radius:10px;
          background: rgba(255,255,255,0.08);
          border:1px solid rgba(255,255,255,0.25);
          text-decoration:none;
        }
        .site-footer .social-link:hover{
          background: rgba(255,255,255,0.14);
          text-decoration:none;
        }
        .site-footer .social-link svg{
          width:18px; height:18px; flex:0 0 18px;
        }
        @media (max-width:900px){
          .site-footer .cols{ grid-template-columns:1fr; }
        }
      `}</style>

      <div className="inner">
        <div className="cols" aria-label="Liens utiles">
          <div>
            <h4>Légal</h4>
            <ul>
              <li><Link to="/rgpd">Politique de confidentialité (RGPD)</Link></li>
              <li><Link to="/conditions">Conditions générales d’utilisation & mentions légales</Link></li>
            </ul>
          </div>
          <div>
            <h4>Guides</h4>
            <ul>
              <li><Link to="/guides">Guides pratiques</Link></li>
              <li><Link to="/demenagement">Déménagement</Link></li>
              <li><Link to="/outils/lettre-preavis-location">Lettre de préavis location</Link></li>
              <li><Link to="/guides/preavis-location-1-mois-ou-3-mois">Préavis : 1 mois ou 3 mois</Link></li>
              <li><Link to="/checklists/checklist-demenagement-pdf">Checklist déménagement</Link></li>
              <li><Link to="/checklists/checklist-visite-logement">Checklist visite logement</Link></li>
              <li><Link to="/cartes">Cartes immobilier, loyers et risques</Link></li>
              <li><Link to="/partenaires/widget">Widget adresse pour partenaires</Link></li>
            </ul>
          </div>
            <button
              type="button"
              onClick={() => window.googlefc?.showRevocationMessage?.()}
              style={{
                background: "none",
                border: 0,
                padding: 0,
                color: "inherit",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Paramètres de confidentialité / cookies
            </button>
        </div>

        <div className="contact-line">
          Une question, une requête, une suggestion ?{" "}
          Contactez-nous via&nbsp;<a href={`mailto:${mail}`}>{mail}</a>
        </div>

        <div className="bottom">
          <div>© {year} État du Lieu — Tous droits réservés.</div>

          <div className="socials" aria-label="Réseaux sociaux">
            <a
              className="social-link"
              href={linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Suivez-nous sur LinkedIn"
              title="Suivez-nous sur LinkedIn"
            >
              {/* LinkedIn icon (inline SVG) */}
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM0 8h5v16H0V8zm7.5 0H12v2.2h.06c.63-1.18 2.17-2.42 4.47-2.42 4.78 0 5.66 3.15 5.66 7.25V24h-5v-6.9c0-1.65-.03-3.77-2.3-3.77-2.3 0-2.65 1.79-2.65 3.64V24h-5V8z"/>
              </svg>
              <span>LinkedIn</span>
            </a>
          </div>

          <div>Hébergement OVH (France). Données publiques sourcées.</div>
        </div>
      </div>
    </footer>
  );
}
